import _pt from "prop-types";
import React from 'react';
import { DrawerHeader as BoltDrawerHeader } from '@sainsburys-tech/bolt';
import * as Styled from './DrawerHeader.styles';
import { headerText } from '../../config';

var DrawerHeader = function DrawerHeader(props) {
  var attributeType = props.attributeType;
  if (!attributeType) return null;
  return /*#__PURE__*/React.createElement(BoltDrawerHeader, null, /*#__PURE__*/React.createElement(Styled.DrawerHeaderTitle, null, headerText[attributeType]));
};

DrawerHeader.propTypes = {
  attributeType: _pt.string.isRequired
};
export default DrawerHeader;